<div class="invoice-edit-wrapper">
  <app-loader *ngIf="isLoading || isPageLoading"></app-loader>
  <ng-container *ngIf="!isPageLoading">
    <div class="btn-container">
      <app-button class="mr-10" type="cancel-button" text="Cancel" (clickCallback)="cancelClick()"></app-button>
      <app-button type="save-button" text="Save" [disabled]="saveButtonDisabled"
        (clickCallback)="saveChanges()"></app-button>
    </div>
    <div class=tabs>
      <div class="stepper">
        <app-stepper [steps]="stepperDetails" [hideStepNumber]="true" (stepChangeCallback)="onStepClick($event)"
          [activeStep]="activeStep"></app-stepper>
      </div>
    </div>
  </ng-container>

  <div class="tab-container">
    <ng-container *ngIf="stepperDetails[activeStep] && stepperDetails[activeStep].elementKey == 'Booking Details'">
      <form [formGroup]="formDetails.get('Booking Details')">
        <div class="booking-select-wrapper">
          <ng-container *ngFor="let field of config.bookingConfig">
            <div class="booking-details-select" *ngIf="field.config.visibility.visible">
              <label class="field-label">{{field.config.displayName}}</label>
              <app-field-generator *ngIf="field.elementKey != 'vendor'" [config]="field.config"
                [inputControl]="formDetails.get('Booking Details').get(field.elementKey)"></app-field-generator>
              <app-select *ngIf="field.elementKey == 'vendor'" [config]="field.config" type="dropdown"
                [formControl]="formDetails.get('Booking Details').get(field.elementKey)"
                [getCustomOptionValue]="getVendorValue" [getCustomOptionLabel]="getVendorLabel"
                [options]="(field.config.values && field.config.values.length) ?  field.config.values : vendors">
              </app-select>
            </div>
          </ng-container>
        </div>
      </form>
    </ng-container>

    <!-- Trip details -->
    <ng-container *ngIf="stepperDetails[activeStep] && stepperDetails[activeStep].elementKey == 'Trip Details'">
      <form [formGroup]="formDetails.get('Trip Details')" class="displayFlexRow">
        <div class="col-3 displayFlexColumn">
          <ng-container *ngFor="let field of config.tripConfigPart1">
            <div class="field-wrapper trip-length" *ngIf="field.config.visibility.visible">
              <label class="field-label">{{field.config.displayName}}</label>
              <!-- <div class="field-section"> -->
              <app-field-generator [config]="field.config" class="trip-leg-input"
                [inputControl]="formDetails.get('Trip Details').get(field.elementKey)"></app-field-generator>
              <!-- </div> -->
            </div>
          </ng-container>
        </div>
        <div class="col-2 displayFlexColumn edit-invoice-trip-details">
          <ng-container *ngFor="let field of config.tripConfigPart2">
            <div class="field-wrapper timepicker" *ngIf="field.config.visibility.visible">
              <label class="field-label">{{field.config.displayName}}</label>
              <app-time-picker *ngIf="field.config.visibility.visible" [showClear]="!field.config.mandatory"
                [formControl]="formDetails.get('Trip Details').get(field.elementKey)"
                (changeCallback)="timeChangeCallback($event,field.elementKey)" [twelveHour]="false"
                [editBillingTime]="true">
              </app-time-picker>


             <!-- ---------calendar-------- -->
             <div class="invoice-calendar">
              <mis-input type="rounded" [class]="customStyle">
                <input
                  misTzDp
                  misInput
                  type="text"
                  readonly
                  class="date-input"
                  [dpConfig]="datepickerConfig"
                  placeholder="Select"
                  (dateChange)="onInvoiceDateChange($event,field.elementKey)"
                  [value]="getSelectedDate(field.elementKey)"
                  positionX="end"
                />
              </mis-input>
             </div>
             <!-- ---------calendar-------- -->

              <app-field-generator [config]="field.config"
                [inputControl]="formDetails.get('Trip Details').get(field.elementKey)"></app-field-generator>
            </div>
          </ng-container>
        </div>
      </form>
    </ng-container>

    <!-- Adjustments -->
    <ng-container *ngIf="stepperDetails[activeStep] && stepperDetails[activeStep].elementKey == 'Adjustments'">
      <div class="adjustments-container">

        <div class="file-section">
          <div>
            <label for="selected" class="field-label font-size-16 font-700">Selected Files : <span id="selected" *ngIf="!invoiceSelectedFiles.files.length && !tollSelectedFiles.files.length
            && !permitSelectedFiles.files.length && !parkingSelectedFiles.files.length
            && !othersSelectedFiles.files.length" class="ml-10"> No files selected</span> </label>

          </div>
          <ng-container *ngTemplateOutlet="fileLinks; context: {fileInfo: invoiceSelectedFiles, section: 'selected'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="fileLinks; context: {fileInfo: tollSelectedFiles, section: 'selected'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="fileLinks; context: {fileInfo: permitSelectedFiles, section: 'selected'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="fileLinks; context: {fileInfo: parkingSelectedFiles, section: 'selected'}">
          </ng-container>
          <ng-container *ngTemplateOutlet="fileLinks; context: {fileInfo: othersSelectedFiles, section: 'selected'}">
          </ng-container>
          <div>
            <label for="Already" class="field-label font-size-16 font-700">Already Uploaded files : <span id="Already"
                *ngIf="!invoiceUploadedFiles.fileNames.length && !tollUploadedFiles.fileNames.length
              && !permitUploadedFiles.fileNames.length && !parkingUploadedFiles.fileNames.length
              && !othersUploadedFiles.fileNames.length" class="ml-10">No files uploaded yet</span>
              <app-button
                *ngIf="downloadZipConfig && downloadZipConfig.config.visibility.visible && uploadedDocumentList"
                type="primaryOutline" [text]="downloadZipConfig.config.displayName" class="ml-20"
                (clickCallback)="downloadZip()" prefixIconSrc="assets/download.svg">
              </app-button>
            </label>

            <ng-container
              *ngTemplateOutlet="uploadedfileLinks; context: {fileInfo: invoiceUploadedFiles, section: 'uploaded'}">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="uploadedfileLinks; context: {fileInfo: tollUploadedFiles, section: 'uploaded'}">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="uploadedfileLinks; context: {fileInfo: permitUploadedFiles, section: 'uploaded'}">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="uploadedfileLinks; context: {fileInfo: parkingUploadedFiles, section: 'uploaded'}">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="uploadedfileLinks; context: {fileInfo: othersUploadedFiles, section: 'uploaded'}">
            </ng-container>
          </div>
        </div>

        <div class="flex">
          <form [formGroup]="formDetails.get('Adjustments')" class="adjustments-wrapper">
            <ng-container *ngFor="let field of config.adjustment">
              <ng-container *ngIf="field.config.visibility.visible">
                <ng-container [ngSwitch]="field.elementKey">
                  <div class="adjustment-container">

                    <div class="field-wrapper red" *ngSwitchCase="'vendorBillAmount'">
                      <div class="field-cards">
                        <label class="field-label file-label">{{field.config.displayName}}</label>
                        <app-field-generator [config]="field.config"
                          [inputControl]="formDetails.get('Adjustments').get(field.elementKey)"></app-field-generator>
                      </div>
                      <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                        class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                        (uploadReportCallback)="setImageForUpload($event, 'INVOICE', field.elementKey)">
                      </app-file-upload-input>

                      <div *ngIf="checkVisibilityy('vendorInvoiceUploadMandatory','vendorBillAmount')"
                        class="mb-10 error-msg isVisible">{{field.config.displayName}} file upload is mandatory</div>
                    </div>
                    <div class="field-wrapper" *ngSwitchCase="'toll'">
                      <div class="field-cards">

                        <label class="field-label">{{field.config.displayName}}</label>
                        <app-field-generator [config]="field.config"
                          [inputControl]="formDetails.get('Adjustments').get(field.elementKey)"></app-field-generator>
                      </div>
                      <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                        class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                        (uploadReportCallback)="setImageForUpload($event, 'TOLL', field.elementKey)" [multiple]="true">
                      </app-file-upload-input>
                      <div *ngIf="checkVisibilityy('tollUploadMandatory','toll')" class="mb-10 error-msg isVisible">
                        {{field.config.displayName}} file upload is mandatory
                      </div>
                    </div>
                    <div class="field-wrapper" *ngSwitchCase="'parking'">
                      <div class="field-cards">
                        <label class="field-label">{{field.config.displayName}}</label>
                        <app-field-generator [config]="field.config"
                          [inputControl]="formDetails.get('Adjustments').get(field.elementKey)"></app-field-generator>
                      </div>
                      <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                        class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                        (uploadReportCallback)="setImageForUpload($event, 'PARKING', field.elementKey)"
                        [multiple]="true">
                      </app-file-upload-input>
                      <div *ngIf="checkVisibilityy('parkingUploadMandatory','parking')"
                        class="mb-10 error-msg isVisible">
                        {{field.config.displayName}} file upload is mandatory</div>
                    </div>

                    <div class="field-wrapper" *ngSwitchCase="'permit'">
                      <div class="field-cards">
                        <label class="field-label">{{field.config.displayName}}</label>
                        <app-field-generator [config]="field.config"
                          [inputControl]="formDetails.get('Adjustments').get(field.elementKey)"></app-field-generator>
                      </div>
                      <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                        class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                        (uploadReportCallback)="setImageForUpload($event, 'PERMIT', field.elementKey)"
                        [multiple]="true">
                      </app-file-upload-input>
                      <div *ngIf="checkVisibilityy('permitUploadMandatory','permit')" class="mb-10 error-msg isVisible">
                        {{field.config.displayName}} file upload is mandatory
                      </div>
                    </div>
                    <div class="field-wrapper" *ngSwitchCase="'otherCost'">
                      <div class="field-cards">

                        <label class="field-label">{{field.config.displayName}}</label>
                        <!-- <app-field-generator *ngIf="miscelleneousConfig['showOthersAmountField'] === 'true'"
                        [config]="field.config" [inputControl]="formDetails.get('Adjustments').get(field.elementKey)">
                      </app-field-generator> -->
                        <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                          class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                          (uploadReportCallback)="setImageForUpload($event,  'OTHERS', field.elementKey)"
                          [multiple]="true">
                        </app-file-upload-input>
                      </div>
                      <div *ngIf="checkOthersFieldVisibility()" class="mb-10 error-msg isVisible">
                        {{field.config.displayName}} file upload is mandatory
                      </div>
                    </div>

                    <div class="field-wrapper" *ngSwitchDefault>
                      <div class="field-cards">
                        <label class="field-label">{{field.config.displayName}}</label>
                        <app-field-generator [config]="field.config"
                          [inputControl]="formDetails.get('Adjustments').get(field.elementKey)"></app-field-generator>
                      </div>
                      <app-file-upload-input accept="image/jpeg, image/jpg, image/png, application/pdf"
                        class="file-input" labelText='Upload File (.png, jpeg, jpg and pdf )'
                        (uploadReportCallback)="setImageForUpload($event,  'PENALTY', field.elementKey)"
                        [multiple]="true">
                      </app-file-upload-input>

                    </div>

                  </div>
                  <div class="field-wrapper full-width" *ngSwitchCase="'comments'">
                    <div class="field-cards comments-container">

                      <label class="field-label">{{field.config.displayName}}</label>
                      <app-text-input [multiline]="true" placeholder="field.config.placeholder"
                       class="adjust-comment"
                        [formControl]="formDetails.get('Adjustments').get('comments')"
                        [ngClass]=" comments? 'comment-field' : ''">
                      </app-text-input>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </form>


        </div>

      </div>
    </ng-container>
  </div>

  <!-- Reusing this for Showing selected files -->
  <ng-template #fileLinks let-fileInfo="fileInfo" ; let-section="section">
    <div *ngIf="fileInfo.fileNames && fileInfo.fileNames.length" class="ml-10">
      <p class="font-bold">{{fileInfo.displayName}}</p>
      <p *ngFor="let fileName of fileInfo.fileNames; let index=index;" class="link ml-10 flex">
        <mat-icon class="color-red pl-10 cross-icon" (click)="cancelFileSelection(fileInfo.type, index, section)">cancel
        </mat-icon>
        <span (click)="previewDocument(fileInfo.files[index])" class="ml-10">{{fileName}}</span>
      </p>
    </div>
  </ng-template>

  <!-- Reusing this for Showing already uploaded files -->
  <ng-template #uploadedfileLinks let-fileInfo="fileInfo" ; let-section="section">
    <div *ngIf="fileInfo.fileNames && fileInfo.fileNames.length" class="ml-10">
      <p class="font-bold">{{fileInfo.displayName}}</p>
      <p *ngFor="let file of fileInfo.fileNames; let index=index;" class="link ml-10 flex">
        <mat-icon class="color-red pl-10 cross-icon" (click)="cancelFileSelection(fileInfo.type, index, section)">cancel
        </mat-icon>
        <span (click)="previewUploadedDocument(file)" class="ml-10">{{file.fileName}}</span>
      </p>
    </div>
  </ng-template>


  <app-file-upload *ngIf="showFileUploadModal" [fileToUpload]="fileToUpload"
    (submitUploadReportCallback)="submitUploadReport()" (handleDismissUploadFileModal)="handleDismissUploadFileModal()"
    [uploadFileError]="uploadFileError">
  </app-file-upload>
  <app-toast *ngIf="showUploadSuccess" message="Upload Successful" (dismissCallback)="toggleToast()">
  </app-toast>
  <app-dialog *ngIf="invoiceDetailsError" titleText="Invoice Update Error" (approveCallback)="hideInvoiceError()"
    type="alert" [buttonText]="['Okay']">
    {{invoiceDetailsError}}
  </app-dialog>
</div>
<app-popover *ngIf="showPreview" class="view-invoice-form" (closeCallback)="closePopOver()" size="full"
  [fullHeight]="true">
  <div popover-header>
    {{selectedFileName}}
  </div>
  <div popover-content style="height: calc(100vh)">
    <ng-container *ngIf="selectedFileType === 'application/pdf'; else imagePreview">
      <div *ngIf="previewUrl" class="height-100-p width-100-p">
        <iframe [cachedSrc]="previewUrl" class="height-100-p width-100-p"></iframe>
      </div>
    </ng-container>
    <ng-template #imagePreview>
      <div *ngIf="previewUrl">
        <img [src]="previewUrl" />
      </div>

    </ng-template>

    <div class="error" *ngIf="errorInGettingImage">No document is available. Please check with your transport team.
    </div>
  </div>
</app-popover>

<app-dialog *ngIf="showFileSizeError" titleText="Upload limit exceeded" (approveCallback)="showFileSizeError = false"
  type="alert" [buttonText]="['OK']">
  File upload limit(20MB) exceeded. Please remove some files and upload again within the given limit.
</app-dialog>